import { render, staticRenderFns } from "./PeopleTypeCreate.vue?vue&type=template&id=c5119f0c&scoped=true"
import script from "./PeopleTypeCreate.vue?vue&type=script&lang=js"
export * from "./PeopleTypeCreate.vue?vue&type=script&lang=js"
import style0 from "./PeopleTypeCreate.vue?vue&type=style&index=0&id=c5119f0c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5119f0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5119f0c')) {
      api.createRecord('c5119f0c', component.options)
    } else {
      api.reload('c5119f0c', component.options)
    }
    module.hot.accept("./PeopleTypeCreate.vue?vue&type=template&id=c5119f0c&scoped=true", function () {
      api.rerender('c5119f0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cashinternal/PeopleTypeCreate.vue"
export default component.exports